import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../../stores/CurrentCompanyStore'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { IPayment } from '@getgreenline/homi-shared'
import { Currency } from '../../components/Currency'
import { FormError } from '../../components/FormError'
import { LoadingAnimation } from '../../components/LoadingAnimation'
import { Track } from '../../Track'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  payment: IPayment
  onComplete: () => void
  onClose: () => void
}

interface State {
  isSaving: boolean
  completed: boolean
  errorMessage?: string
}

@inject('currentCompanyStore')
@observer
export class CompletePaymentModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isSaving: false,
      completed: false,
      errorMessage: undefined,
    }
  }

  complete() {
    const payment = this.props.payment
    this.setState({
      isSaving: true,
    })
    this.props
      .currentCompanyStore!.completePayment(payment.locationId, payment.id)
      .then(() => {
        Track.track('dashboard:payments_completed', payment)
        this.setState({
          isSaving: false,
          completed: true,
          errorMessage: undefined,
        })
        this.props.onComplete()
      })
      .catch((error) => {
        this.setState({
          isSaving: false,
          errorMessage: error.response.data.message || 'There was an error completing this sale',
        })
      })
  }

  render() {
    const payment = this.props.payment

    let body: JSX.Element
    if (!this.state.completed) {
      body = (
        <div>
          <p>
            This sale will be set to complete. If inventory has not been removed yet, it will be
            after completion.
          </p>
          {payment.wooCommerceOrderId ? (
            <div>
              <p>
                Your attached WooCommerce order will also be set to be completed, and trigger any
                associated emails to the customer.
              </p>
              <p>
                Your WooCommerce order ID: <b>{payment.wooCommerceOrderId}</b>
              </p>
            </div>
          ) : undefined}
          <br />
          <div>
            {this.state.isSaving ? (
              <button className='btn btn-lg btn-success w-100' disabled>
                Completing...
              </button>
            ) : (
              <button className='btn btn-lg btn-success w-100' onClick={() => this.complete()}>
                Complete
              </button>
            )}
          </div>
        </div>
      )
    } else {
      body = (
        <div style={{ textAlign: 'center' }}>
          <br />
          <div className='fa fa-check mb-1' style={{ fontSize: '7em', color: 'green' }} />
          <p>This sale has been successfully completed.</p>
          <br />
        </div>
      )
    }

    return (
      <Modal isOpen={true} toggle={() => this.props.onClose()} autoFocus={false}>
        <ModalHeader toggle={() => this.props.onClose()}>Complete sale</ModalHeader>
        <ModalBody>
          {body}
          <FormError message={this.state.errorMessage} />
        </ModalBody>
      </Modal>
    )
  }
}
